/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Get_Login_Link_ButtonInputs */

const en_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get login link`)
};

const id_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan tautan login`)
};

const ms_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan pautan log masuk`)
};

const ca_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir l'enllaç d'inici de sessió`)
};

const cs_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získat odkaz pro přihlášení`)
};

const da_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hent login-link`)
};

const de_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldelink anfordern`)
};

const et_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hangi sisselogimise link`)
};

const es_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtener enlace para iniciar sesión`)
};

const fr_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir le lien de connexion`)
};

const hr_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pošalji poveznicu za prijavu`)
};

const it_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni link di accesso`)
};

const lv_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saņemt pieteikšanās saiti`)
};

const lt_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gauti prisijungimo nuorodą`)
};

const hu_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bejelentkezési link kérése`)
};

const nl_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloglink vragen`)
};

const nb_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send innloggingslenke`)
};

const pl_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzyskaj link do zalogowania`)
};

const pt_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obter link de login`)
};

const ro_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obțineți link-ul de conectare`)
};

const sk_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získať prihlasovací odkaz`)
};

const sl_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pridobi povezavo za prijavo`)
};

const fi_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanki kirjautumislinkki`)
};

const sv_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hämta inloggningslänk`)
};

const vi_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy liên kết đăng nhập`)
};

const tr_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş bağlantısı al`)
};

const el_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λήψη συνδέσμου σύνδεσης`)
};

const bg_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получаване на линк за влизане`)
};

const ru_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите ссылку для входа в систему`)
};

const sr_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошаљи линк за пријаву`)
};

const uk_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримати посилання для входу`)
};

const ka_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მიიღეთ შესვლის ბმული`)
};

const hi_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉगिन लिंक पाएं`)
};

const th_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับลิงก์เข้าสู่ระบบ`)
};

const ko_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 링크 받기`)
};

const zh_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取登录链接`)
};

const zh_tw_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取得登入連結`)
};

const ja_get_login_link_button = /** @type {(inputs: Get_Login_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインリンクを取得`)
};

/**
* | output |
* | --- |
* | "Get login link" |
*
* @param {Get_Login_Link_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const get_login_link_button = /** @type {((inputs?: Get_Login_Link_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Get_Login_Link_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_get_login_link_button(inputs)
	if (locale === "ms") return ms_get_login_link_button(inputs)
	if (locale === "ca") return ca_get_login_link_button(inputs)
	if (locale === "cs") return cs_get_login_link_button(inputs)
	if (locale === "da") return da_get_login_link_button(inputs)
	if (locale === "de") return de_get_login_link_button(inputs)
	if (locale === "et") return et_get_login_link_button(inputs)
	if (locale === "es") return es_get_login_link_button(inputs)
	if (locale === "fr") return fr_get_login_link_button(inputs)
	if (locale === "hr") return hr_get_login_link_button(inputs)
	if (locale === "it") return it_get_login_link_button(inputs)
	if (locale === "lv") return lv_get_login_link_button(inputs)
	if (locale === "lt") return lt_get_login_link_button(inputs)
	if (locale === "hu") return hu_get_login_link_button(inputs)
	if (locale === "nl") return nl_get_login_link_button(inputs)
	if (locale === "nb") return nb_get_login_link_button(inputs)
	if (locale === "pl") return pl_get_login_link_button(inputs)
	if (locale === "pt") return pt_get_login_link_button(inputs)
	if (locale === "ro") return ro_get_login_link_button(inputs)
	if (locale === "sk") return sk_get_login_link_button(inputs)
	if (locale === "sl") return sl_get_login_link_button(inputs)
	if (locale === "fi") return fi_get_login_link_button(inputs)
	if (locale === "sv") return sv_get_login_link_button(inputs)
	if (locale === "vi") return vi_get_login_link_button(inputs)
	if (locale === "tr") return tr_get_login_link_button(inputs)
	if (locale === "el") return el_get_login_link_button(inputs)
	if (locale === "bg") return bg_get_login_link_button(inputs)
	if (locale === "ru") return ru_get_login_link_button(inputs)
	if (locale === "sr") return sr_get_login_link_button(inputs)
	if (locale === "uk") return uk_get_login_link_button(inputs)
	if (locale === "ka") return ka_get_login_link_button(inputs)
	if (locale === "hi") return hi_get_login_link_button(inputs)
	if (locale === "th") return th_get_login_link_button(inputs)
	if (locale === "ko") return ko_get_login_link_button(inputs)
	if (locale === "zh") return zh_get_login_link_button(inputs)
	if (locale === "zh-tw") return zh_tw_get_login_link_button(inputs)
	if (locale === "ja") return ja_get_login_link_button(inputs)
	return en_get_login_link_button(inputs)
});